import { ApiResponse } from "interface/response"
import { AxiosApi } from "./index";
import { UserAgreementForm } from "interface/userAgreement";


export async function registerUserAgreementApi(form: UserAgreementForm) {
    const apiUri = "UserAgreement/Register"

    try {
        const registration = await AxiosApi.post<ApiResponse<any>>(apiUri, form)

        return registration.data
    } catch (error) {
        throw error
    }
}

export async function getUserAgreementsApi() {
    const apiUri = "UserAgreement/List";
    try {
        const res = await AxiosApi.get<ApiResponse<any>>(apiUri);

        //console.log('result', res.data.data);

        return res.data.data;
    } catch (error) {
        throw error;
    }
}

export async function approveUserAgreementUserApi(customerId: number): Promise<ApiResponse<{userId: string, agreementId:number}>> {
    const apiUri = "UserAgreement/ApproveUser";
    try {
        const res = await AxiosApi.post<ApiResponse<{userId: string, agreementId:number}>>(apiUri, { customerId });
        return res.data;
    } catch (error) {
        throw error;
    }
}

export async function deleteUserAgreementUserApi(id: number) {
    const apiUri = "UserAgreement/RemoveRegisteredUser"; 
    try {
        const res = await AxiosApi.post<ApiResponse<any>>(apiUri, { id });
        return res.data;
    } catch (error) {
        throw error;
    }
}

export async function getCatchSignerUserApi(username: string): Promise<{ isValid: boolean; signUser: { firstname: string; lastname: string; email: string; username: string; phoneNumber: string } }> {
    const apiUri = `UserAgreement/CatchSigner`;
    try {
        const res = await AxiosApi.get<{ isValid: boolean; signUser: { firstname: string; lastname: string; email: string; username: string; phoneNumber: string } }>(apiUri, { params: { username } });
        return res.data;
    } catch (error) {
        throw error;
    }
}